<template>
  <v-container v-if="fulfillment.id" :loading="loading">
    <v-row>
      <v-col>
        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="fulfillment.positions"
              dense
              disable-sort
              disable-pagination
              hide-default-footer
              class="elevation-1"
            >
              <template #top>
                <v-toolbar flat>
                  <v-toolbar-title>Enthaltene Positionen</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical />
                  <v-spacer />
                </v-toolbar>
              </template>
              <template #body="{items: positions}">
                <tbody>
                  <template v-for="position in positions">
                    <tr :key="position.id" style="background-color: gray;">
                      <td>{{ position.pos }}</td>
                      <td colspan="2">
                        {{ position.title }}
                      </td>
                    </tr>
                    <template v-for="positionItem in position.items">
                      <tr :key="positionItem.id">
                        <td>{{ position.pos }}.{{ positionItem.pos }}</td>
                        <td>{{ positionItem.title }}</td>
                        <td>{{ positionItem.amount }}</td>
                      </tr>
                    </template>
                  </template>
                </tbody>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <a class="v-btn v-btn--flat v-btn--text theme--light v-size--small primary--text" :href="route('contracts.fulfillments.showReceipt', {'contract': contract.id, 'fulfillment': fulfillment.id})" target="_blank">
              Übergabeschein anzeigen
            </a>
          </v-col>
        </v-row>
      </v-col>
      <v-dialog v-model="addArticleDialog" width="500">
        <v-card>
          <v-card-title>
            Artikel Hinzufügen
          </v-card-title>
          <v-card-text>
            <v-select v-model="itemToAdd" label="Artikel" return-object item-text="name" :items="purchaseItems" />
            <v-select v-model="positionToAdd" label="Position" return-object :items="computedPositions">
              <template #item="{item}">
                {{ item.major_pos }}.{{ item.pos }} - {{ item.name }}
              </template>
              <template #selection="{item}">
                {{ item.major_pos }}.{{ item.pos }} - {{ item.name }}
              </template>
            </v-select>
            <v-text-field v-model="amountToAdd" label="Menge" type="number" />
          </v-card-text>
          <v-card-actions class="d-flex justify-end">
            <v-btn color="secondary" text @click="addArticleDialog = false">
              Abbrechen
            </v-btn>
            <v-btn text color="primary" @click="addItemToPosition">
              Artikel Hinzufügen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-col>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="articleHeaders"
              :items="articles"
              item-key="key"
              sort-by="pos_number"
              group-by="pos"
              class="elevation-1"
              show-group-by
              :items-per-page="-1"
              hide-default-footer
            >
              <template #top>
                <v-toolbar flat>
                  <v-toolbar-title>zugehörige Einkaufsartikel</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical />
                  <v-spacer />
                  <v-btn color="primary" @click="addArticleDialog = true">
                    Artikel Hinzufügen
                  </v-btn>
                </v-toolbar>
              </template>
              <template #[`item.amount`]="{item}">
                <v-text-field v-model="item.amount" type="number" :rules="[v => !!v|| 'Anzahl wird benötigt']" />
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn text color="primary" @click="save">
              Speichern
            </v-btn>
            <v-btn v-if="!fulfillment.articles_requested" color="primary" @click="reserveArticles">
              artikel reservieren
            </v-btn>
            <span v-else>
              Artikel wurden bereits Reserviert
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Übergabe',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      fulfillment: {
         type: Object,
         required: true,
      },
      contract: {
         type: Object,
         required: true,
      },
      articles: {
         type: Array,
         required: true,
      },
      purchaseItems: {
         type: Array,
         required: true
      }
   },
   data () {
      return {
         loading: true,
         headers: [
            {
               text: 'Pos.',
               align: 'start',
               filterable: false,
               value: 'pos',
            },
            { text: 'Beschreibung', value: 'title' },
            { text: 'Anzahl', value: 'amount' },
         ],
         articleHeaders: [
            { text: 'Pos-Text', value: 'pos', align: 'left', width: '400px', sort: function (a, b) { return parseFloat(a) - parseFloat(b) } },
            { text: 'Article', value: 'name', align: 'left', width: '400px', sortable: false },
            { text: 'Anzahl', value: 'amount', align: 'left', groupable: false, sortable: false },
         ],
         itemToAdd: {},
         positionToAdd: {},
         amountToAdd: 0,
         addArticleDialog: false
      }
   },
   computed: {
      computedPositions () {
         const positions = []
         for (const index in this.fulfillment.positions) {
            const position = this.fulfillment.positions[index]
            for (const itemIndex in position.items) {
               const item = position.items[itemIndex]
               const found = positions.filter(obj => {
                  return obj.post === item.pos
               })
               if (found.length > 0) {
                  continue
               }
               positions.push({
                  pos: item.pos,
                  major_pos: position.pos,
                  id: item.id,
                  name: item.title
               })
            }
         }
         return positions
      }
   },
   methods: {
      positionBackground (pos) {
         return {
            backgroundColor:
          pos !== undefined && !String(pos).includes('.')
             ? 'gray'
             : 'transparent',
         }
      },

      itemText (item) {
         return item.product.last_data[0].name + ' - ' + item.last_data[0].name
      },
      positionText (item) {
         return item.last_data[0].name
      },
      submit () {
         this.fulfillmentCreation.post(
            this.route('contracts.fulfillments.store', {
               contract: this.contract.id,
            })
         )
      },
      reserveArticles () {
         this.$inertia.patch(this.route('contracts.fulfillments.reserveArticles', {
            contract: this.contract.id,
            fulfillment: this.fulfillment.id
         }), this.articles)
      },
      addItemToPosition () {
         const payload = {
            item: this.itemToAdd,
            position: this.positionToAdd,
            amount: this.amountToAdd
         }
         this.$inertia.patch(this.route('contracts.fulfillments.add-item-position', this.contract.id), payload, {
            onSuccess: function () {
               this.addArticleDialog = false
            }
         })
      },
      save () {
         this.$inertia.patch(this.route('contracts.fulfillments.update', {
            contract: this.contract.id,
            fulfillment: this.fulfillment.id
         }), this.articles)
      }
   },
}
</script>
